module.exports = __webpack_public_path__ + "static/media/bg-profile.d9252e67.png";